import { ca } from "date-fns/locale";

const initialState = {
  employee_tax: [],
  error: null,
  isLoding: false
};

const EmployeeTaxApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...state,
        isLoding: action.payload
      };

    case "GET_EMPLOYEE_TAX_SUCCESS":
      return {
        ...state,
        employee_tax: action.payload,
        error: null
      };
    case "GET_EMPLOYEE_TAX_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_EMPLOYEE_TAX_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_EMPLOYEE_TAX_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_EMPLOYEE_TAX_SUCCESS":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_EMPLOYEE_TAX_FAILURE":
      return {
        ...state,

        error: action.payload.error
      };

    case "DELETE_EMPLOYEE_TAX_SUCCESS":
      return {
        ...state,
         employee_tax: state.employee_tax.filter(
      (tax) => tax.id !== action.payload.id
    ),
        error: null
      };

    case "DELETE_EMPLOYEE_TAX_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
   
    default:
      return state;
  }
};

export default EmployeeTaxApiReducer;
